import { render, staticRenderFns } from "./index.vue?vue&type=template&id=499fc6c0&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogNewsArticles: require('/home/vsts/work/1/a/NuxtApp/components/blog/NewsArticles.vue').default,BlogLayout: require('/home/vsts/work/1/a/NuxtApp/components/blog/Layout.vue').default})
